import ResetPassword from '../Component/ResetPassword';
import { connect } from 'react-redux';
import { newPassword } from '../../../../Actions/index';


const mapStateToProps = (state) => {
  const { resetPWD } = state;
  return {
    resetPWD
  }
}


const actionCreators = {
  newPassword
}
export default (connect(mapStateToProps, actionCreators)(ResetPassword));